import { fetchJSON } from '../utilities/fetch';
import { AttributeChoice } from './products';

interface QuantityByVariantAttributeChoices {
  quantity: number;
  variantAttributeChoices: { [attributeId: string]: string };
  selectionId: string;
}

export interface Project {
  id: string;
  lastModified: string;
  merchandisingProductId: string;
  flowState: string;
  // all other props should be optional
  quantitiesByVariantAttributeChoices?: QuantityByVariantAttributeChoices[];
  accessories?: string[]; // todo: this is an array, but it might not be strings
}

export async function getProject(projectId: string): Promise<Project> {
  return fetchJSON<Project>(
    `https://project.storefront.vpsvc.com/v5/${projectId}?requestor=upload-design`,
    {
      method: 'GET',
      description: `get project: ${projectId}`,
    },
  );
}

export async function createProject(
  merchandisingProductId: string,
  sku: string,
  quantity: number,
  attributeChoices: AttributeChoice[],
) {
  // attributesChoices have the shape { attributeId: string, choiceId: string }, but we need { [attributeId: string]: choiceId }
  const variantAttributeChoices = attributeChoices.reduce<{ [attributeId: string]: string }>(
    (acc, attributeChoice) => {
      acc[attributeChoice.attributeId] = attributeChoice.choiceId;
      return acc;
    },
    {},
  );

  const project = {
    merchandisingProductId,
    flowState: 'UploadDesignFlow',
    quantitiesByVariantAttributeChoices: [
      {
        quantity,
        variantAttributeChoices,
      },
    ],
    documentSource: {
      sourceType: 'design',
      data: `f_${sku}`,
    },
  };

  return fetchJSON<Project>('https://project.storefront.vpsvc.com/v5?requestor=upload-design', {
    method: 'POST',
    body: JSON.stringify(project),
    description: 'create project',
  });
}
